import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION}.${BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.EXTERNAL_PARTNERS_AND_ADVISERS}` as const;

export const WORK_EXPERIENCE_NAMES = {
  EMPLOYER: 'employer',
  POSITION: 'position',
} as const;
      
export interface IWorkExperience {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: string;
  [WORK_EXPERIENCE_NAMES.POSITION]: string;
}
      
export const workExperienceInitialValues: IWorkExperience = {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: '',
  [WORK_EXPERIENCE_NAMES.POSITION]: '',
};

export const LIST_OF_EXTERNAL_PARTNERS_NAMES = {
  FILE: 'file',
  NAME: 'name',
  SURNAME: 'surname',
  ROLE: 'role',
  WORK_EXPERIENCE: 'workExperience',
  KEY_SKILLS: 'keySkills',
} as const;
    
export interface IListOfExternalPartners{
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.FILE]: IImageFile[];
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.NAME]: string;
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.SURNAME]: string;
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.ROLE]: string;
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.WORK_EXPERIENCE]: IWorkExperience[];
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.KEY_SKILLS]: string,
}
    
export const listOfExternalPartnersInitialValues: IListOfExternalPartners = {
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.FILE]: [],
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.NAME]: '',
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.SURNAME]: '',
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.ROLE]: '',
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.WORK_EXPERIENCE]: [workExperienceInitialValues],
  [LIST_OF_EXTERNAL_PARTNERS_NAMES.KEY_SKILLS]: '',
};

export const EXTERNAL_PARTNERS_AND_ADVISERS_NAMES = {
  LIST_OF_EXTERNAL_PARTNERS: 'listOfExternalPartners',
  PARTNERS: 'partners',
  CRITERIA: 'criteria',
  PLANS: 'plans',
} as const;
  
export interface IExternalPartnersAndAndAdvisers{
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.LIST_OF_EXTERNAL_PARTNERS]: IListOfExternalPartners[];
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PARTNERS]: string;
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.CRITERIA]: string;
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PLANS]: string;
}
  
export const externalPartnersAndAndAdvisersInitialValues: IExternalPartnersAndAndAdvisers = {
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.LIST_OF_EXTERNAL_PARTNERS]: [listOfExternalPartnersInitialValues],
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PARTNERS]: '',
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.CRITERIA]: '',
  [EXTERNAL_PARTNERS_AND_ADVISERS_NAMES.PLANS]: '',
};